
























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { ImportacaoDeNota } from '@/models/ImportacaoDeNota'
import { ImportarNotaDoFornecedorUseCase } from '@/usecases/fornecedor/ImportarNotaDoFornecedorUseCase'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import CabecalhoDaNota from '../componentes/CabecalhoDaNota.vue'
import {
	obterChaveNota,
	obterNumeroNota,
	corDoStatus as corStatus,
	iconeDoStatus as iconeStatus,
	estaEmProcessamento,
} from '@/usecases/importacao-de-notas/importacaoHelpers'

const INTERVALO_POLLING_MS = 4000

/**
 * Etapa 1 — upload do XML e identificação da nota.
 * Fluxo (reaproveitando o backend existente):
 *  1. upload → execute() (POST /gerar) enfileira o processamento assíncrono
 *  2. polling de status (buscarItensDeImportacao)
 *  3. ao concluir, "Abrir" carrega a nota por chave (buscarImportacaoDeNota) e emite 'nota-carregada'
 */
@Component({
	components: { CabecalhoDaNota },
})
export default class EtapaUpload extends Vue {
	@Prop({ type: Object, default: null }) importacao!: ImportacaoDeNota | null

	arquivo: File | null = null
	carregando = false
	carregandoStatus = false
	abrindo = ''
	processamentos: any[] = []
	private timer: number | null = null

	private useCase = new ImportarNotaDoFornecedorUseCase()

	headers = [
		{ text: 'Nota', value: 'numero', sortable: false },
		{ text: 'Status', value: 'status', sortable: false },
		{ text: 'Progresso', value: 'progresso', sortable: false },
		{ text: '', value: 'acoes', sortable: false, align: 'end' },
	]

	get usuario(): string | undefined {
		return UserLoginStore.usuario?.id
	}

	mounted() {
		this.buscarStatus()
		this.timer = window.setInterval(() => {
			if (this.processamentos.some(p => estaEmProcessamento(p.status))) {
				this.buscarStatus()
			}
		}, INTERVALO_POLLING_MS)
	}

	beforeDestroy() {
		if (this.timer) window.clearInterval(this.timer)
	}

	corDoStatus(status: string): string {
		return corStatus(status)
	}

	iconeDoStatus(status: string): string {
		return iconeStatus(status)
	}

	chaveDoItem(item: any): string {
		const conteudo = item && item.itens && item.itens[0] ? item.itens[0].item : ''
		return obterChaveNota(conteudo)
	}

	numeroDoItem(item: any): string | null {
		const conteudo = item && item.itens && item.itens[0] ? item.itens[0].item : ''
		return obterNumeroNota(conteudo)
	}

	async processarXml() {
		if (!this.arquivo) return
		try {
			this.carregando = true
			await this.useCase.execute(this.arquivo)
			AlertModule.setWarning('Leitura do XML iniciada. Aguarde o processamento concluir para abrir a nota.')
			this.arquivo = null
			await this.buscarStatus()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	async buscarStatus() {
		if (!this.usuario) return
		try {
			this.carregandoStatus = true
			this.processamentos = await this.useCase.buscarItensDeImportacao(this.usuario)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoStatus = false
		}
	}

	async abrir(item: any) {
		const chave = this.chaveDoItem(item)
		if (!chave) {
			AlertModule.setError('Chave de acesso da nota não encontrada. Acione o suporte.')
			return
		}
		try {
			this.abrindo = chave
			const importacao = await this.useCase.buscarImportacaoDeNota(chave)
			if (importacao) this.$emit('nota-carregada', importacao)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.abrindo = ''
		}
	}
}
